import React from 'react';
import SMSpaceResource from 'resources/SMSpaceResource';

class SMFormSpaceSelectBox extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      ownerId: this.props.ownerId,
      selectedValue: this.props.selectedValue,
      spaceId: this.props.spaceId,
      spaces: [],
    };
  }
  
  componentDidMount(){
    this.requestResource();
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      spaceId : nextProps.spaceId,
    });
  }
  
  requestResource(){
    SMSpaceResource.getSpaces({owner_id: this.state.ownerId, per_page: 250}, (spaces, error)=>{
      if(!error) {
        this.setState({spaces : spaces});
      }
    });
  }
  
  didChangeValue(e) {
    if(this.props.delegate && typeof this.props.delegate.spaceSelectBoxDidChangeValue === 'function'){
      this.props.delegate.spaceSelectBoxDidChangeValue(e.currentTarget.value);
    }
  }
  
  renderOptions(){
    let rows = [];
    for (let i = 0; i < this.state.spaces.length; i++) {
      const space = this.state.spaces[i];
      rows.push(
        <option key={space.id} value={space.username}>{space.name}</option>
      );
    }
    return rows;
  }

  render() {
    return (
      <select name="space_id" value={this.state.spaceId || ''} className={this.props.options.className} onChange={this.didChangeValue.bind(this)} disabled={this.props.options.disabled}>
        <option value="">{I18n.t("dashboard.label_000104")}</option>
        {this.renderOptions()}
      </select>
    );
  }
}

SMFormSpaceSelectBox.defaultProps = {
  options: {
    className: "",
    disabled: false
  },
};

export default SMFormSpaceSelectBox;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormSpaceSelectBox.jsx